import { Package } from '../../models/package';
import { PackageQuery } from '../../models/package-query';
import { createSelector } from '@ngrx/store';

export interface PackageTableState {
    query: PackageQuery;
    page: Package[];
    totalCount?: number;
    filteredCount?: number;
    busy: boolean;
    error: boolean;
    selection: string[];
}

export const selectPackageTableState = (state: any) => state.packageTable;

export const selectPackageTableQuery = createSelector(selectPackageTableState,
    (state: PackageTableState) => state.query);

export const selectPackageTablePage = createSelector(selectPackageTableState,
    (state: PackageTableState) => state.page);

export const selectPackageTableBusy = createSelector(selectPackageTableState,
    (state: PackageTableState) => state.busy);

export const selectPackageTableCount = createSelector(selectPackageTableState,
    (state: PackageTableState) => state.totalCount);

export const selectPackageTableSelection = createSelector(selectPackageTableState,
    (state: PackageTableState) => state.selection);

export const selectPackageTableError = createSelector(selectPackageTableState,
    (state: PackageTableState) => state.error);
